import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { NavItem } from '../../types';
import MobileMenu from '../MobileMenu';
import styles from './Header.module.css';

interface HeaderProps {
  navigationData: NavItem[];
}

const Header: React.FC<HeaderProps> = ({ navigationData }) => {
  const [activeNavId, setActiveNavId] = useState<string | null>(null);
  const [showSubmenu, setShowSubmenu] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [headerActive, setHeaderActive] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 0) {
        setIsScrolled(true);
      } else {
        setIsScrolled(false);
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleNavMouseEnter = (navId: string) => {
    setActiveNavId(navId);
    setShowSubmenu(true);
    setHeaderActive(true);
  };

  const handleHeaderMouseLeave = () => {
    setActiveNavId(null);
    setShowSubmenu(false);
    setHeaderActive(false);
  };

  const headerClasses = [
    styles.mainHeader,
    headerActive ? styles.active : '',
    isScrolled ? styles.scroll : ''
  ].filter(Boolean).join(' ');

  // 스크롤이나 호버 시 다크 로고 사용
  const logoSrc = (isScrolled || headerActive) ? '/images/logo-dark.png' : '/images/logo.png';

  return (
    <header className={headerClasses} onMouseLeave={handleHeaderMouseLeave}>
      <div className={styles.headerContainer}>
        <div className={styles.headerLogo}>
          <Link to="/">
            <img src={logoSrc} alt="한국승강기안전원 로고" />
          </Link>
        </div>

        <nav className={styles.mainNav}>
          <ul className={styles.navList}>
            {navigationData.map((navItem) => (
              <li
                key={navItem.id}
                className={`${styles.navItem} ${activeNavId === navItem.id ? styles.on : ''}`}
                onMouseEnter={() => handleNavMouseEnter(navItem.id)}
              >
                <Link to={navItem.href} className={styles.navLink}>
                  {navItem.label}
                </Link>
                <div className={`${styles.submenu} ${showSubmenu ? styles.show : ''}`}>
                  <ul className={styles.dropdownList}>
                    {navItem.submenu.map((subItem) => (
                      <li key={subItem.id}>
                        {subItem.isExternal ? (
                          <a
                            href={subItem.href}
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            {subItem.label}
                            {subItem.icon && (
                              <>
                                {/*&nbsp;*/}
                                <img
                                  src={subItem.icon}
                                  alt=""
                                  style={{ verticalAlign: 'middle' }}
                                />
                              </>
                            )}
                          </a>
                        ) : (
                          <Link to={subItem.href}>
                            {subItem.label}
                          </Link>
                        )}
                      </li>
                    ))}
                  </ul>
                </div>
              </li>
            ))}
          </ul>
          <div className={`${styles.submenuBg} ${showSubmenu ? styles.show : ''}`} />
        </nav>

          <button
              className={`${styles.menuToggle} ${mobileMenuOpen ? styles.open : ''}`}
              onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
              aria-label="전체메뉴"
          >
              <span></span>
              <span></span>
              <span></span>
          </button>
      </div>

      <MobileMenu
        navigationData={navigationData}
        isOpen={mobileMenuOpen}
        onClose={() => setMobileMenuOpen(false)}
      />
    </header>
  );
};

export default Header;
